<template>
  <div style="display: flex;">
    <div v-if="!smAndDown" style="font-size: 15px;">
      <div style="padding-top: 9px; padding-right: 1rem; color: black">
        Страницы:
      </div>
      <div style="height: 11px"/>
    </div>
    <div :style="`width: 36px; ${!scrollReachedEnd && pdfDocumentLoaded ? 'cursor: pointer' : ''}`" @click="scrollByArrow(true)">
      <v-icon v-if="scrollPosition > 0" large color="#009933">mdi-chevron-left</v-icon>
    </div>
    <div :class="!smAndDown ? 'scroll scroll-bw-7' : 'scroll scroll-bw'" :style="`display: flex; overflow-x: auto; ${smAndDown ? 'max-width: calc(98vw - 72px)' : 'max-width: 45vw'}; padding-bottom: 0.25rem;`" @scroll="onPageScrollerScroll" id="pageScroller">
      <div v-for="page in countPages" :key="'pageSelector-' + page" @click="goToPage(page)" style="padding-top: 6px;" v-if="participants">
        <v-badge class="page-select-element">
          <div style="color: #5e5e5e; padding-top: 0.65rem; position: absolute; font-size: 12px;">
            {{page}}
          </div>
          <svg v-if="page !== currentPage" width="21" height="29" viewBox="0 0 21 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.6438 1.2145L12.498 6.88742C12.4542 8.17075 13.3584 9.33742 14.6417 9.33742H19.8772M4.15633 0.645752C2.39175 0.645752 0.947998 2.10408 0.947998 3.91242V25.0874C0.947998 26.8958 2.39175 28.3541 4.15633 28.3541H16.6688C18.4334 28.3541 19.8772 26.8958 19.8772 25.0874L19.8917 8.827C19.8917 8.72492 19.9063 8.5645 19.8626 8.477C19.6438 8.02492 20.0084 8.09784 19.673 7.76242L13.1688 1.28742C12.8917 1.01034 12.5417 0.806169 12.1626 0.718669C12.0022 0.674919 11.8126 0.645752 11.6376 0.645752H4.15633Z" stroke="#444444" stroke-miterlimit="22.9256"/>
          </svg>
          <svg v-else width="21" height="29" viewBox="0 0 21 29" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12.6438 1.2145L12.498 6.88742C12.4542 8.17075 13.3584 9.33742 14.6417 9.33742H19.8772M4.15633 0.645752C2.39175 0.645752 0.947998 2.10408 0.947998 3.91242V25.0874C0.947998 26.8958 2.39175 28.3541 4.15633 28.3541H16.6688C18.4334 28.3541 19.8772 26.8958 19.8772 25.0874L19.8917 8.827C19.8917 8.72492 19.9063 8.5645 19.8626 8.477C19.6438 8.02492 20.0084 8.09784 19.673 7.76242L13.1688 1.28742C12.8917 1.01034 12.5417 0.806169 12.1626 0.718669C12.0022 0.674919 11.8126 0.645752 11.6376 0.645752H4.15633Z" stroke="#E58C3F" stroke-miterlimit="22.9256"/>
          </svg>
          <template v-slot:badge>
            <span style="top: -12px; right: -8px; font-size: 8px" v-if="badgeCount(page)" >{{badgeCount(page)}}</span>
          </template>
          <div style="height: 7px"/>
        </v-badge>
      </div>
    </div>
    <div @click="scrollByArrow(false)" :style="`width: 36px; ${!scrollReachedEnd && pdfDocumentLoaded ? 'cursor: pointer' : ''}`">
      <v-icon v-if="!scrollReachedEnd && pdfDocumentLoaded" large color="#009933">mdi-chevron-right</v-icon>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'
  export default {
    props: {
      currentPage: [Number, Array],
      countPages: Number,
      pdfDocumentLoaded: Boolean,
      participants: Array,
    },
    data: () => ({
      scrollPosition: 0,
      scrollLeft: 0,
    }),
    computed: {
      scrollReachedEnd() {
        const tmp = this.scrollPosition
        const el = document.getElementById('pageScroller')
        if (!el)  return true
        return this.between(tmp, el.scrollWidth - el.offsetWidth - 1, el.scrollWidth - el.offsetWidth + 1) || el.scrollWidth - el.offsetWidth === 0
      },
      smAndDown() {
        return this.$vuetify.breakpoint.smAndDown
      },
    },
    methods: {
      scrollByArrow(left) {
        const el = document.getElementById('pageScroller')
        left ? el.scrollLeft -= 250 : el.scrollLeft += 250
      },
      onPageScrollerScroll(element) {
        this.scrollPosition = element.srcElement.scrollLeft
      },
      goToPage(value) {
        this.$emit('goToPage', value)
      },
      badgeCount(page) {
        let allStamps = 0
        _.forEach(this.participants, (participant) => {
          allStamps += participant.stamps[page].isVisible ? 1 : 0
        })
        return allStamps
      },
      between(x, min, max) {
        return x >= min && x <= max
      },
    },
  }
</script>

<style lang="scss">
  .pdf-document {
    .pdf-document__page {
      position: relative;
    }
    gap: 30px;
    display: flex;
    flex-direction: column;
  }

  .pdf-form-locally-classes {
    // max-height: 70vh;
    // overflow-y: scroll;
    overflow-x: clip;
  }

  .green-bordered-btn {
    border: 1px solid #009933;
    color: #009933;
    border-radius: 4px;
    font-size: 16px;
    width: 150px;
    height: 34px;
  }

  .page-select-btn {
    height: 30px;
    width: 22px;
    border: solid 1px #4F4F4F;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .v-badge.page-select-element {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 7px;
    cursor: pointer
  }

  span .v-badge__badge {
    top: -6px !important;
    right: 14px !important;
    height: 13px !important;
    min-width: 10px !important;
    display: flex !important;
  }

 @mixin scroll-style($size: 10px,
  $thumb: none,
  $thumb-color: grey,
  $thumb-radius: 10px,
  $track-color: transparent,
  $track-radius: 10px) {

  // Respaldo para Firefox
  scrollbar-color: $thumb-color $track-color;
  scrollbar-width: thin;

  // Navegadores basados en webkit
  &::-webkit-scrollbar {
    width: $size;
    height: $size;
    &-track {
      background-color: $track-color;
      border-radius: $track-radius;
    }
    &-thumb {
      background-color: $thumb-color;
      background-image: $thumb;
      border-radius: $thumb-radius;
    }
  }
}

.scroll {
  @include scroll-style(
    $size: var(--scroll-size, 10px),
    $thumb:  var(--scroll-thumb, none),
    $thumb-color: var(--scroll-thumb-color, grey),
    $thumb-radius: var(--scroll-thumb-radius, var(--scroll-radius)),
    $track-color: var(--scroll-track, transparent),
    $track-radius: var(--scroll-track-radius, var(--scroll-radius)),
  );
  &-bw {
    --scroll-size: 5px;
    --scroll-radius: 10px;
    --scroll-track: rgb(223, 223, 223);
    --scroll-thumb-color: #9c9c9c;
  }
  &-bw-7 {
    --scroll-size: 6px;
    --scroll-radius: 10px;
    --scroll-track: rgb(223, 223, 223);
    --scroll-thumb-color: #9c9c9c;
  }
}
</style>
